import React from "react";
import MainPoster from "./Components/MainPoster";
import About from "./Components/About";
import Projects from "./Components/Projects";
import OpenToWork from "./Components/OpenToWork";

const Homepage = () => {
  return (
    <>
      <MainPoster />
      <About />
      <Projects />
      <OpenToWork />
    </>
  );
};

export default Homepage;
